/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sendEmailCapture/sendEmailContainerService"/>
import * as rest from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";
import * as emailValidator from "Core/Medius.Core.Web/Scripts/Medius/core/validation/email";
import { EmailType } from "../emailStatusTab/models/emailEntryDto";

export const getCompanyUsers = (companyId: number): Promise<CompanyUserListItem[]> =>
    rest.get(`remedium-api/invoiceimageusers/${companyId}`)
        .then(response => response)
        .then(users => users.map((receiver: RestInvoiceImageReceiver) => {
            const emailOrUsername = receiver.email == "" ? receiver.userName : receiver.email;
            return new CompanyUserListItem(receiver.name, emailOrUsername, receiver.email);
        }));

export const sendEmail = (captureEmailInfo: EmailInfo | CaptureEmailInfo, recipients: string[]): Promise<any> => {
    if (captureEmailInfo as CaptureEmailInfo) {
        return rest.post("Backend/Rpc/MediaManager/SendEmailCapture", new Email(captureEmailInfo, recipients));
    }

    return rest.post("Backend/Rpc/MediaManager/SendEmail", new Email(captureEmailInfo, recipients));
};

export const ResendEmail = (emailInfo: ResendEmailInfo, toRecipients: string[], ccRecipients: string[], sendMeACopy: boolean, asHtml: boolean, resendForCapture: boolean): Promise<any> => {
    const result = rest.post("remedium-api/MediaManager/ResendEmail", new ResendEmailRequest(emailInfo, toRecipients, ccRecipients, sendMeACopy, asHtml, resendForCapture));
    return result;
};

export const validateEmail = (email: string): boolean => emailValidator.getRegex().test(email);

export class EmailInfo {
    constructor(public subject: string, public message: string, public docId: number,
        public docType: string, public hash: string, public tag: string) { }
}

export class CaptureEmailInfo {
    constructor(public subject: string, public message: string, public docId: number, public docType: string, public ccfInvoiceId: string, public userTaskId?: number) { }
}

export class ResendEmailInfo {
    constructor(public subject: string, public message: string, public emailType: EmailType, public docId: number,
        public docType: string, public hash?: string, public tag?: string, public ccfInvoiceId?: string, public userTaskId?: number) { }
}

export class Email {
    constructor(public emailInfo: EmailInfo | CaptureEmailInfo, public receivers: string[]) { }
}

export class ResendEmailRequest {
    constructor(public emailInfo: ResendEmailInfo, public toReceivers: string[], public ccReceivers: string[], public sendMeACopy: boolean, public asHtml: boolean, public resendForCapture: boolean) { }
}

export class CompanyUserListItem {
    constructor(public text: string, public value: string, public subText?: string) { }
}

export class Recipient {
    constructor(public name: string, public email: string) { }
}

interface RestInvoiceImageReceiver {
    id: number; userName: string; name: string; email: string
}